module.exports = __webpack_public_path__ + "img/eu.b7f2d7c.svg";